export var Users;
(function (Users) {
    let UserRole;
    (function (UserRole) {
        UserRole["YouthBuilder"] = "youth-builder";
        UserRole["AdultBuilder"] = "adult-builder";
        UserRole["Parent"] = "parent";
        UserRole["Admin"] = "admin";
    })(UserRole = Users.UserRole || (Users.UserRole = {}));
    Users.roleMap = {
        [UserRole.YouthBuilder]: "youth-builder",
        [UserRole.AdultBuilder]: "adult-builder",
        [UserRole.Parent]: "parent",
        [UserRole.Admin]: "admin",
    };
})(Users || (Users = {}));
//# sourceMappingURL=schema.js.map